module.exports = "<div class=\"container\">\n  <img class=\"icon\" src=\"{{iconUrl}}\" alt=\"{{title}}\" (click)=\"onClick()\"/>\n</div>\n"